export const ONEDESK_ACADEMY_URL = 'https://academy.onedesk.io/'
